<template>
    <component
        :is="element"
        :href="href"
        v-bind="$attrs"
        :disabled="disabled"
        :class="
            disabled
                ? 'text-gray-700 bg-gray-100 hover:bg-gray-200'
                : 'text-indigo-700 bg-indigo-100 hover:bg-indigo-200'
        "
        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
        <svg v-if="action === 'activate'" viewBox="0 0 20 20" fill="currentColor" class="eye w-4 h-4">
            <path
                d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
            ></path>
        </svg>
        <svg v-if="action === 'show'" viewBox="0 0 20 20" fill="currentColor" class="eye w-4 h-4">
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path>
            <path
                fill-rule="evenodd"
                d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg v-if="action === 'calendar'" viewBox="0 0 20 20" fill="currentColor" class="eye w-4 h-4">
            <path
                fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg v-else-if="action === 'edit'" viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
            <path
                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
            ></path>
        </svg>
        <svg v-else-if="action === 'quiz'" viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
            <path
                fill-rule="evenodd"
                d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'grid-add'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'play'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <IconCopy v-else-if="action === 'duplicate'" class="w-4 h-4" />
        <svg
            v-else-if="action === 'add'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'print'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'comment'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'chart'"
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"
            ></path>
        </svg>
        <svg
            v-else-if="action === 'impersonate'"
            class="w-4 h-4"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
            ></path>
        </svg>
        <IconExternalLink class="w-4 h-4" v-else-if="action === 'external_link'" />
        <IconStarFilled class="w-4 h-4" v-else-if="action === 'star'" />
        <IconStatusChange class="w-4 h-4" v-else-if="action === 'change_user'" />
        <IconEyeOff class="w-4 h-4" v-else-if="action === 'eye_closed'" />
        <IconEye class="w-4 h-4" v-else-if="action === 'eye'" />
        <IconList class="w-4 h-4" v-else-if="action === 'list'" />
        <IconEdit class="w-4 h-4" v-else-if="action === 'grade'" />
        <IconTrash class="w-4 h-4" v-else-if="action === 'delete'" />
        <IconReportAnalytics class="w-4 h-4" v-else-if="action === 'analysis'" />
        <svg
            v-else-if="action === 'template'"
            viewBox="0 0 24 24"
            class="print w-4 h-4"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <rect x="4" y="4" width="16" height="4" rx="1"></rect>
            <rect x="4" y="12" width="6" height="8" rx="1"></rect>
            <line x1="14" y1="12" x2="20" y2="12"></line>
            <line x1="14" y1="16" x2="20" y2="16"></line>
            <line x1="14" y1="20" x2="20" y2="20"></line>
        </svg>
    </component>
</template>

<script>
import {
    IconCopy,
    IconEdit,
    IconExternalLink,
    IconEye,
    IconEyeOff,
    IconList,
    IconReportAnalytics,
    IconStarFilled,
    IconStatusChange,
    IconTrash,
} from '@tabler/icons-vue';

export default {
    components: {
        IconCopy,
        IconList,
        IconExternalLink,
        IconStatusChange,
        IconEdit,
        IconStarFilled,
        IconEyeOff,
        IconEye,
        IconTrash,
        IconReportAnalytics,
    },
    props: {
        type: {
            type: String,
            default: 'show',
        },
        href: {
            type: String,
            required: true,
        },
        action: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        element: {
            type: String,
            default: 'inertia-link',
        },
    },
};
</script>
